import { h, type FunctionalComponent } from '@stencil/core';
import type { IDashboardDesktopView } from '../dashboard-views/dashboard-desktop-view';

type DashboardOffsitesV4Props = Pick<IDashboardDesktopView, 'analyticsTabName' | 'tabName' | 'query' | 'brand' | 'country' | 'language' | 'relatedProductName' | 'rtl' >;

export const DashboardOffsitesV4: FunctionalComponent<DashboardOffsitesV4Props> = (props) => {
    const {
      country,
      language,
      brand,
      relatedProductName,
      analyticsTabName,
      tabName,
      query,
      rtl,

    } = props;

    return (
      <div
        class={{
          'offsites-container': true,
          'widget-offset--rtl': rtl
        }}
      >
        <uiaas-offsites-widget-v4
          term={query}
          country={country}
          language={language}
          is-dashboard-view={true}
          brand={brand}
          tab-name={tabName}
          analytics-tab-name={analyticsTabName}
          relatedProductName={relatedProductName}
          class="dashboard-offsites-widget"
        />
      </div>
    );
};
